import { connect } from "react-redux";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Typography
} from "@mui/material";
import * as React from "react";
import { successToast } from "./Notification";
import { getSuccessMessage } from "../store/helpers/common_functions";


function DeleteDialog({ open, setOpen, DeleteAction, PutAction, usePut, url, onSuccess, info, title, bodyText, maxWidth, body, buttonTitle, alertMessage, systemSettings }) {

    const backgroundColor = systemSettings?.mainBackground || '#56677d'; 

    const [deleting, setDeleting] = React.useState(false);
    const [error, setError] = React.useState();

    const handleClose = () => {
        setError(null);
        setOpen(false);
    }

    return <Dialog open={open} fullWidth={true} maxWidth={maxWidth ?? 'xs'} onClose={handleClose}>
        {deleting ? (
            <div
                className={
                    "absolute h-full w-full top-0 left-0 flex z-50 justify-center items-center"
                }
                style={{ backgroundColor: info ? "rgba(83,220,85,0.2)" : "rgba(220,83,83,0.2)" }}
            >
                <div
                    className={"bg-white p-3 rounded shadow text-center"}
                    style={{ zIndex: 20000 }}
                >
                    <div>
                        <CircularProgress color={info ? 'success' : "error"} />
                    </div>
                    <span>
                        <Typography color={info ? 'success' : 'error'}>{info || usePut ? 'Submitting' : 'Deleting'} ....</Typography>
                    </span>
                </div>
            </div>
        ) : null}
        <DialogTitle className="text-capitalize">{title ?? (info ? 'Action Alert' : 'Delete Alert')}</DialogTitle>
        <DialogContent>
            {alertMessage ?
                <Alert severity={"warning"}>
                    {alertMessage}
                </Alert>
                : null}
            {error ? (
                <Alert
                    style={{ width: "100%" }}
                    className={"mb-3"}
                    severity={"error"}
                    onClose={() => setError(null)}
                >
                    {error}
                </Alert>
            ) : null}
            <div className={'text-center'}>
                <DialogContentText>{bodyText ?? (info ||usePut ? 'Are you sure ?' : 'Are you sure, you want to delete this item ?')}</DialogContentText>
            </div>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={async () => {
                setDeleting(true);
                const resp = info || usePut ? await PutAction(url, body) : await DeleteAction(url);
                if (resp.status) {
                    handleClose();
                    successToast(getSuccessMessage(resp));
                    if (onSuccess && typeof onSuccess === 'function') {
                        onSuccess(resp);
                    }
                } else {
                    setError(resp?.data?.response?.data.message ?? "Error Found !!");
                }
                setDeleting(false);
            }} variant={'contained'} sx={{
                backgroundColor:backgroundColor,
                color: 'white',
                '&:hover': {
                    backgroundColor: backgroundColor,
                },
            }} color={info ? 'success' : 'error'}>{buttonTitle ?? (info ? 'Next' : 'Delete')}</Button>
        </DialogActions>
    </Dialog>
}

export default connect(null, mapDispatchToProps)(DeleteDialog);